import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Box, IconButton, Typography } from '@mui/material';
import Tooltip from 'components/Tooltip';
import CustomerBrand from 'components/V2/Sidebar/components/CustomerBrand';
import PropTypes from 'prop-types';

import { selectCompany } from 'redux/selectors/auth';
import { setSidebarCollapse } from 'redux/slices/general';

import styles from '../dashboard.module.css';

import { ReactComponent as ExpandIcon } from 'asset/IconsPack/at_chevron-right-double.svg';
import { ReactComponent as MenuIcon } from 'asset/IconsPack/at_menu-03-filled.svg';

import SwitchEnvironment from './SwitchEnvironment';

function PageBar({ isTablet, isMobile, handleToggler }) {
    const dispatch = useDispatch();
    const company = useSelector(selectCompany);
    const sidebarCollapse = useSelector((state) => state.general?.sidebarCollapse);
    const companyName = company?.company_name || '';

    return (
        <Box className={styles.pageBar}>
            {isTablet && (
                <IconButton
                    className={styles.menuButton}
                    data-tour="menu"
                    onClick={handleToggler}
                    aria-label="Open menu"
                >
                    <MenuIcon className={styles.menuIcon} />
                </IconButton>
            )}
            {!isTablet && sidebarCollapse && (
                <Tooltip title="Expand sidebar" placement="bottom">
                    <IconButton
                        className={styles.expandButton}
                        data-tour="sidebar-toggle"
                        onClick={() => dispatch(setSidebarCollapse(false))}
                        aria-label="Expand sidebar"
                        disableRipple
                    >
                        <ExpandIcon className={styles.expand_icon} />
                    </IconButton>
                </Tooltip>
            )}
            <Box className={styles.company}>
                <CustomerBrand companyName={companyName} className={styles.companyLogo} />
                <Typography className={styles.companyName} title={companyName}>
                    {companyName}
                </Typography>
            </Box>
            <SwitchEnvironment isMobile={isMobile} />
        </Box>
    );
}

PageBar.propTypes = {
    isTablet: PropTypes.bool,
    isMobile: PropTypes.bool,
    handleToggler: PropTypes.func,
};

export default PageBar;
